var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "frankinForm" }, [
      _c("form", [
        _c("div", { staticClass: "frankinForm__stepOne step" }, [
          _c("div", { staticClass: "in container" }, [
            _c("div", { staticClass: "inputPanel" }, [
              _c(
                "div",
                { staticClass: "inputPanel__col inputPanel__question" },
                [
                  _c("label", [
                    _vm._v(
                      "Is this current solution still in under lease contract?"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "inputPanel__col inputPanel__input" }, [
                _c("ul", { staticClass: "toggleBtns toggleBtns--fullWidth" }, [
                  _c("li", [
                    _c("input", {
                      attrs: { type: "radio", id: "byes", name: "underlease" }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "byes" } }, [_vm._v("yes")])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        id: "bleaseexpired",
                        name: "underlease"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bleaseexpired" } }, [
                      _vm._v("no the lease has expired")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        id: "bnopurchased",
                        name: "underlease"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bnopurchased" } }, [
                      _vm._v("no its purchased")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        id: "bidontknow",
                        name: "underlease"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bidontknow" } }, [
                      _vm._v("i don't know")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputPanel__col inputPanel__info" }, [
                _c("div", { staticClass: "infoIcon" }, [
                  _vm._v("\n              i\n            ")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputmodal" }, [
                _c("div", { staticClass: "in" }, [
                  _c("div", { staticClass: "inputmodal__close" }, [
                    _c("img", {
                      attrs: { src: "/static/styles/mailkit/img/multiply.svg" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters "
                    ),
                    _c("span", { staticClass: "modelClose" }, [_vm._v("(X)")])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-430d3b42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430d3b42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Temp.vue
// module id = null
// module chunks = 